<template>
  <v-dialog v-model="dialog" max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn outlined color="primary" v-bind="attrs" v-on="on">{{
        $t('title_msg_delivery_create')
      }}</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h6 primary--text">
          {{ $t('title_msg_delivery_create') }}
        </span>
      </v-card-title>
      <v-card-subtitle class="pt-2 pt-md-4">
        <span>
          {{ $t('cap_msg_delivery_create_info') }}
        </span>
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="form" @submit.prevent>
          <v-row no-gutters>
            <v-col cols="12" sm="12">
              <v-text-field
                v-model="newAgent.name"
                :rules="nameRule"
                hint="Delivery Agent Name"
                persistent-hint
                outlined
                @keyup.enter="onSubmit"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-text-field
                v-model="newAgent.phone"
                :rules="phoneNumberRule"
                :hint="$t('cap_from_reg_emp_phone')"
                persistent-hint
                outlined
                @keyup.enter="onSubmit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text class="primary--text" @click="onCancel">
          {{ $t('btn_txt_cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="onSubmit">
          {{ $t('btn_cap_save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import PhoneNumber from 'awesome-phonenumber'

export default {
  data () {
    return {
      dialog: false,
      newAgent: {
        name: '',
        phone: ''
      }
    }
  },
  methods: {
    onCancel () {
      this.dialog = false
      this.newAgent = {
        name: '',
        phone: ''
      }
      this.$refs.form.resetValidation()
    },
    onSubmit () {
      if (this.$refs.form.validate()) {
        this.newAgent.name = this.newAgent.name.trim()

        // Phone Number Verification
        let pn
        this.newAgent.phone = /\s/.test(this.newAgent.phone)  ? this.newAgent.phone.replace(/\s/g,'') : this.newAgent.phone
        if (this.newAgent.phone.startsWith('+') || !this.newAgent.phone.startsWith('0')) {
          // this must be e164 format (i.e. prefixed with a +)
          this.newAgent.phone = !this.newAgent.phone.startsWith('+') ? `+${this.newAgent.phone}` : this.newAgent.phone
          pn = new PhoneNumber(this.newAgent.phone)
        } else {
          // let use cambodia format here
          pn = new PhoneNumber(this.newAgent.phone, 'KH')
        }
        this.newAgent.phone = pn.getNumber('e164')
        console.log('new Delivery Agent', this.newAgent)
        this.$store.dispatch('deliveryAgent/createDeliveryAgents', this.newAgent)
          .then(() => {
            this.onCancel()
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  },
  computed: {
    phoneNumberRule () {
      return [
        v => !!v || this.$t('cap_msg_setting_form_err_003'),
        v => {
          // 039 is special case of phone number from (star Digital/Kingtel Network)
          v = /\s/.test(v) ? v.replace(/\s/g, '') : v
          if (!v.startsWith('039') && !v.startsWith('+85539')) {
            let pn
            if (v.startsWith('+') || !v.startsWith('0')) {
              // this must be e164 format (i.e. prefixed with a +)
              v = !v.startsWith('+') ? `+${v}` : v
              pn = new PhoneNumber(v)
            } else {
              // let use cambodia format here
              pn = new PhoneNumber(v, 'KH')
            }
            return pn.isValid() || this.$t('cap_msg_setting_form_err_004')
          } else {
            let format = /^[0-9]{9,10}$/
            if (v.startsWith('+85539')) {
              format = /^['+']{1}[0-9]{11,12}$/
            }
            return format.test(v) || this.$t('cap_msg_setting_form_err_004')
          }
          return true
        },
        v => {
          v = /\s/.test(v) ? v.replace(/\s/g, '') : v
          const format = /^['+']{0,1}[0-9]*$/
          return format.test(v) || this.$t('cap_msg_err_001')
        }
      ]
    },
    nameRule () {
      return [
        v => !!v || this.$t('cap_msg_setting_form_err_001'),
        v => {
          const format = /([a-zA-Z])+([ -~])*/
          return format.test(v) || this.$t('cap_msg_setting_form_err_002')
        }
      ]
    }
  }
}
</script>
